import Vue from "vue";
import MdButton from "vue-material/dist/components/MdButton";
import MdCheckbox from "vue-material/dist/components/MdCheckbox";
import MdField from "vue-material/dist/components/MdField";
import MdList from "vue-material/dist/components/MdList";
import MdMenu from "vue-material/dist/components/MdMenu";
import MdProgress from "vue-material/dist/components/MdProgress";
import MdSwitch from "vue-material/dist/components/MdSwitch";
import MdTabs from "vue-material/dist/components/MdTabs";
import "vue-material/dist/vue-material.min.css";
import "./index.scss";

Vue.use(MdButton);
Vue.use(MdCheckbox);
Vue.use(MdField);
Vue.use(MdList);
Vue.use(MdMenu);
Vue.use(MdProgress);
Vue.use(MdSwitch);
Vue.use(MdTabs);

Vue.component(
  "MdSelect",
  Vue.options.components.MdSelect.extend({
    methods: {
      isInvalidValue: function isInvalidValue() {
        return this.$el.validity
          ? this.$el.validity.badInput
          : this.$el.querySelector("input").validity.badInput;
      },
    },
  })
);
